import { render, staticRenderFns } from "./UserSelfExclude.vue?vue&type=template&id=0d1cce8f&"
import script from "./UserSelfExclude.vue?vue&type=script&lang=js&"
export * from "./UserSelfExclude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserSelfExclude.vue"
export default component.exports